<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Login form</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text ref="form">
            <v-text-field
              ref="nik"
              v-model="nik"
              label="NIK"
              prepend-icon="mdi-account"
              type="text"
              :rules="[rules.nik]"
            />

            <v-text-field
              v-model="password"
              label="Password"
              prepend-icon="mdi-lock"
              type="password"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="login">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import firebase from 'firebase';
require('firebase/auth');

import AdminAPIServices from "../services/AdminAPIServices";
import KaryawanAPIServices from "../services/KaryawanAPIServices";
import AuthService from "../services/AuthService";
import { mapMutations } from "vuex";

export default {
  data: () => ({
    rules: {
      nik: (value) => !!value || "Masukkan NIK.",
    },

    nik: "",
    password: "",

    dialog: false,

    headers: [
      {
        text: "Kode Kategori",
        align: "start",
        value: "kode",
        sortable: false,
      },
      { text: "Nama Kategori", value: "nama", sortable: false },
      { text: "Action", value: "actions", sortable: false },
    ],
    kategoris: [],

    editedIndex: -1,
    editedItem: {
      kode: "",
      nama: "",
    },
    defaultItem: {
      kode: "",
      nama: "",
    },

    page: 1,
    pageCount: 1,
    itemsPerPage: 10,
  }),

  created() {
    this.initialize();
  },

  computed: {
    form() {
      return {
        nik: this.nik,
      };
    },

    validate() {
      var formHasErrors = false;

      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) formHasErrors = true;

        this.$refs[f].validate(true);
      });

      return !formHasErrors;
    },
  },

  methods: {
    initialize() {},
    async login() {
      if (this.validate) {
        this.$store.commit("showProgress", {
          message: "Generating API Key",
        });

        try {
          // Step 1: Generate API Key
          await AuthService.generateApiKey();
          
          this.$store.commit("showProgress", {
            message: "Generating Firebase Token",
          });

          // Step 2: Generate Firebase Token with NIK and PIN
          await AuthService.generateFirebaseToken(this.nik, this.password);
          
          this.$store.commit("showProgress", {
            message: "Validating NIK",
          });

          // Step 3: Validate NIK using new authentication
          const responseAdmin = await AdminAPIServices.getByNIK(this.nik);
          
          this.$store.commit("showProgress", {
            message: "Validating PIN",
          });

          // Step 4: Validate PIN
          const body = { pin: this.password };
          await KaryawanAPIServices.login(this.nik, body);
          
          this.$store.commit("showProgress", {
            message: "Setting up session",
          });

          // Step 6: Setup session
          this.$session.start();
          this.$session.set("nik", this.nik);
          this.$session.set("role", responseAdmin.data.role);

          this.$store.commit("closeProgress");
          this.$router.replace({ path: "/" });

        } catch (error) {
          // Clear tokens on any error
          AuthService.logout();
          
          // Sign out from Firebase
          try {
            await firebase.auth().signOut();
          } catch (firebaseError) {
            console.error("Firebase signout error:", firebaseError);
          }

          this.$store.commit("closeProgress");
          
          // Handle different types of errors
          let errorMessage = "Login gagal";
          
          if (error.response) {
            if (error.response.data?.message) {
              errorMessage = error.response.data.message;
            } else if (error.response.status === 401) {
              errorMessage = "NIK atau PIN tidak valid";
            } else if (error.response.status >= 500) {
              errorMessage = "Server error, silakan coba lagi";
            }
          } else if (error.request) {
            errorMessage = "Koneksi ke server gagal";
          } else if (error.message) {
            errorMessage = error.message;
          }

          this.showSnackbar({
            color: "error",
            message: errorMessage,
          });
        }
      } else {
        this.showSnackbar({
          color: "error",
          message: "Input tidak valid",
        });
      }
    },
    ...mapMutations(["showSnackbar"]),
  },
};
</script>
